var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReady
    ? _c("div", { staticClass: "time-worked-page" }, [
        _c(
          "div",
          { staticClass: "time-filter-wrap" },
          [
            _c(
              "portal-filter-bar",
              { attrs: { label: _vm.$t("global.filter") } },
              [
                _vm.view === "list"
                  ? _c("portal-search-field", {
                      attrs: {
                        label: _vm.$t("global.filter"),
                        placeholder: _vm.$t("global.filter"),
                        "clear-label": _vm.$t("global.clear")
                      },
                      on: { change: _vm.handleFilterChange },
                      model: {
                        value: _vm.filter,
                        callback: function($$v) {
                          _vm.filter = $$v
                        },
                        expression: "filter"
                      }
                    })
                  : _vm._e(),
                _c("portal-select-field", {
                  attrs: {
                    label: _vm.$t("global.date"),
                    options: _vm.dateOptions
                  },
                  on: { change: _vm.handleDateFilterChange },
                  model: {
                    value: _vm.dateFilter,
                    callback: function($$v) {
                      _vm.dateFilter = $$v
                    },
                    expression: "dateFilter"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "time-worked-content show-scrollbar" },
          [
            _c("timer-event-table", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.view === "list",
                  expression: "view === 'list'"
                }
              ],
              attrs: { "timer-events": _vm.timerEvents, filter: _vm.filter }
            }),
            _vm.view === "reports"
              ? _c("timer-event-charts", {
                  attrs: {
                    "timer-events": _vm.timerEvents,
                    earliest: _vm.earliest,
                    latest: _vm.latest
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }